function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "mastercard",
  transform: "translate(0 -54.719)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7",
  "data-name": "Caminho 7",
  d: "M14.048,61.745a7.024,7.024,0,1,1-7.024-7.026A7.024,7.024,0,0,1,14.048,61.745Z",
  fill: "#e2574c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_8",
  "data-name": "Caminho 8",
  d: "M116.457,54.719a6.985,6.985,0,0,0-4.2,1.4h.006a6.019,6.019,0,0,1,.681.636l-1.461.023a7.225,7.225,0,0,0-.634.744h2.577a6.529,6.529,0,0,1,.542.7h-3.586a7,7,0,0,0-.359.7h4.353a5.983,5.983,0,0,1,.3.678h-4.913a6.766,6.766,0,0,0-.2.743h5.315c.052.243.092.468.119.7h-5.539c-.023.231-.035.466-.035.7h5.615a6.172,6.172,0,0,1-.043.7h-5.537q.036.357.105.7h5.306c-.055.228-.118.457-.2.694H109.75a6.82,6.82,0,0,0,.264.7h4.363a6.4,6.4,0,0,1-.409.7h-3.6a6.838,6.838,0,0,0,.469.705l2.588.039a6.838,6.838,0,0,1-.762.656c.014.011-.412,0-1.252-.015a7.024,7.024,0,1,0,5.043-11.912Z",
  transform: "translate(-100.997)",
  fill: "#f4b459"
}));

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.486,
    height: 14.052,
    viewBox: "0 0 22.486 14.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.7c8d670d.svg";
export { ForwardRef as ReactComponent };